import React from 'react';
import styled from 'styled-components';
import { themes } from 'kb-shared';
import { ReactComponent as RightBrace } from '../../../assets/icons/medication-right.svg';
import { ReactComponent as LeftBrace } from '../../../assets/icons/medication-left.svg';

const { colors, fonts } = themes;
const ToDoHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 24px;
  font-size: 24px;
  ${fonts.FoundersGrotesk};
  > p {
    margin: 0;
    ${fonts.DomaineDisplay}
  }
`;

const CountContainer = styled.div`
  display: flex;
  width: 40.5px;
  height: 37.5px;
  margin-right: 8.5px;
  margin-top: 7px;
  svg > path {
    fill: ${colors.KBYellow};
  }
`;
const ToDoCount = (props: { count: number }) => (
  <ToDoHeader>
    <CountContainer>
      <LeftBrace />
      {props.count}
      <RightBrace />
    </CountContainer>
    <p>to-do item{props.count > 1 && 's'} below:</p>
  </ToDoHeader>
);

export default ToDoCount;
